import api from "@/assets/js/api"; // 引用 API 模組

export default {
  props: {
    id: {
      type: String,
      required: false, // id 可能为空
    },
  },
  data() {
    return {
      filters: ["所有訊息", "最新消息", "住宿方案", "餐廳新訊"],
      activeFilter: "所有訊息",
      news: [], // 從後端獲取的新聞資料
      currentPage: 1,
      itemsPerPage: 6,
      selectedNews: null, // 儲存選中的公告
    };
  },
  computed: {
    filteredNews() {
      if (this.activeFilter === "所有訊息") {
        return this.news.slice(
          (this.currentPage - 1) * this.itemsPerPage,
          this.currentPage * this.itemsPerPage
        );
      }
      return this.news
        .filter((item) => item.category === this.activeFilter)
        .slice(
          (this.currentPage - 1) * this.itemsPerPage,
          this.currentPage * this.itemsPerPage
        );
    },
    totalPages() {
      const filtered = this.activeFilter === "所有訊息"
        ? this.news
        : this.news.filter((item) => item.category === this.activeFilter);
      return Math.ceil(filtered.length / this.itemsPerPage);
    },
  },
  methods: {
    filterNews(filter) {
      this.activeFilter = filter;
      this.currentPage = 1; // 重置為第一頁
    },
    openDetail(item) {
      this.selectedNews = item; // 將點擊的卡片內容設定為選中的公告
    },
    closeDetail() {
      this.selectedNews = null; // 關閉詳細內容
    },
    openDetailById(newsId) {
      const newsItem = this.news.find((item) => item.id === Number(newsId));
      if (newsItem) {
        this.selectedNews = newsItem; // 设置选中的新闻
      } else {
        console.error("News not found:", newsId);
      }
    },
    formatContent(content) {
      return content.replace(/\n/g, '<br>'); // 替換 \n 為 <br>
    },
    changePage(action) {
      if (action === "first") {
        // 跳轉到第一頁
        this.currentPage = 1;
      } else if (action === "last") {
        // 跳轉到最後一頁
        this.currentPage = this.totalPages;
      } else if (action === "prev" && this.currentPage > 1) {
        // 上一頁
        this.currentPage--;
      } else if (action === "next" && this.currentPage < this.totalPages) {
        // 下一頁
        this.currentPage++;
      } else if (typeof action === "number") {
        // 跳轉到指定頁
        this.currentPage = action;
      }
    },
    async fetchNews() {
      try {
        const response = await api.get("/news"); // 調用 API.js 中的 GET 方法
        this.news = response.data.map((item) => ({
          id: item.Id,
          date: `${item.Starttime.substring(0, 10)} ~ ${item.Endtime.substring(0, 10)}`, // 格式化日期
          title: item.Title,
          image: require(`@/assets/picture/News/${item.Image}`),
          contents: item.Contents.substring(0, 50) + "...", // 顯示摘要
          fullContent: item.Contents, // 完整公告內容
          category: item.Category, // 分類
        }));
        const newsId = this.$route.query.id; // 检查路由参数
        if (newsId) {
          this.openDetailById(newsId); // 根据 id 打开详细信息
        }
      } catch (error) {
        console.error("Failed to fetch news:", error);
      }
    },
  },
  created() {
    this.fetchNews();
  },
  mounted() {
    const newsId = this.$route.query.id; // 获取 URL 中的 id 参数
  if (newsId) {
    this.openDetailById(newsId); // 根据 id 打开详细信息
  }
  },
  watch: {
    "$route.query.id"(newId) {
      if (newId) {
        this.openDetailById(newId); // 路由参数变化时加载对应的新闻详情
      } else {
        this.selectedNews = null; // 如果 id 被清空，关闭详情
      }
    },
  },
};
